import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@material-ui/core';

export type DialogContentProps = MuiDialogContentProps;

export const DialogContent = MuiDialogContent;
